type Props = {
  intro: string;
  bullets: string[];
  grades: string[];
};

function GdadRoleLevelDefinition({ intro, bullets, grades }: Props) {
  return (
    <div className="gdad-role-level-content">
      {intro && <p className="govuk-body">{intro}</p>}
      {bullets.length > 0 && (
        <>
          <p className="govuk-body">At this role level, you will:</p>
          <ul className="govuk-list govuk-list--bullet">
            {bullets.map((bullet, index) => (
              <li key={`role-level-bullet-${index}`}>{bullet}</li>
            ))}
          </ul>
        </>
      )}
      {grades.length > 0 && (
        <>
          <p className="govuk-body">
            This role level is most often performed at the Civil Service job grade of:
          </p>
          <ul className="govuk-list govuk-list--bullet">
            {grades.map((grade, index) => (
              <li key={`role-level-grade-${index}`}>{grade}</li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
}

export default GdadRoleLevelDefinition;
